<template>
    <div class="flex-form__fieldset">
        <label class="flex-form__field" :class="getInvalidClass('targetId')">
            <div class="flex-form__label">
                Component ID

                <tooltip>
                    You can get the component ID by selecting the component, and then clicking on the fingerprint icon in its toolbar.
                </tooltip>
            </div>

            <input v-model="dataNew.targetId" class="flex-form__input">
        </label>

        <label class="flex-form__field" :class="getInvalidClass('layerNum')">
            <div class="flex-form__label">
                Active Layer

                <tooltip>
                    The layer that you want to want to display. For example, enter "2" to display the second layer.
                </tooltip>
            </div>

            <input v-model="dataNew.layerNum" class="flex-form__input">
        </label>
    </div>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'action-toggle-layered-container',
    mixins: [eventDataMixin],

    computed: {
        schema() {
            return {
                targetId: {
                    type: String,
                    default: '',
                    required: this.dataNew.targetType !== 'self',
                },

                layerNum: {
                    type: Number,
                    required: true,
                },
            };
        },
    },

    mounted() {
        const { elementType, id } = this.selectedElements[0];

        if (elementType === 'o-layered-container' && !this.dataNew.targetId) {
            this.dataNew.targetId = id;
        }
    },
};
</script>
